import { arrayMove as dndArrayMove } from "@dnd-kit/sortable";

export function arrayMove(items, from, to) {
  return dndArrayMove(items, from, to);
}
